import { render, staticRenderFns } from "./ksh2.vue?vue&type=template&id=02250969&scoped=true&"
import script from "./ksh2.vue?vue&type=script&lang=js&"
export * from "./ksh2.vue?vue&type=script&lang=js&"
import style0 from "./ksh2.vue?vue&type=style&index=0&id=02250969&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02250969",
  null
  
)

export default component.exports